import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/charging_cards',
  component: Management,
  redirect: '/charging_cards/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/charging_cards/List'),
      redirect: 'list/active',
      meta: {
        auth: Auth.listChargingCards
      },
      children: [
        {
          path: 'active',
          component: () => import('@/views/charging_cards/ListTable'),
          meta: {
            auth: Auth.listChargingCards,
            activeMenu: '/charging_card_definitions',
            tabName: 'active'
          }
        },
        {
          path: 'pending',
          component: () => import('@/views/charging_cards/ListTable'),
          meta: {
            auth: Auth.listChargingCards,
            activeMenu: '/charging_card_definitions',
            tabName: 'pending'
          }
        },
        {
          path: 'expired',
          component: () => import('@/views/charging_cards/ListTable'),
          meta: {
            auth: Auth.listChargingCards,
            activeMenu: '/charging_card_definitions',
            tabName: 'expired'
          }
        },
        {
          path: 'invalid',
          component: () => import('@/views/charging_cards/ListTable'),
          meta: {
            auth: Auth.listChargingCards,
            activeMenu: '/charging_card_definitions',
            tabName: 'invalid'
          }
        },
        {
          path: 'disabled',
          component: () => import('@/views/charging_cards/ListTable'),
          meta: {
            auth: Auth.listChargingCards,
            activeMenu: '/charging_card_definitions',
            tabName: 'disabled'
          }
        }
      ]
    },
    {
      path: ':id',
      component: () => import('@/views/charging_cards/DetailLayout'),
      meta: {
        auth: Auth.showChargingCard
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/charging_cards/details/Detail'),
          meta: {
            tabName: 'detail',
            auth: Auth.showChargingCard,
            activeMenu: '/charging_card_definitions'
          }
        },
        // 消费记录
        {
          path: 'consumption_records',
          component: () => import('@/views/charging_cards/details/ConsumptionRecords'),
          meta: {
            tabName: 'consumption_records', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showChargingCardDefinition,
            activeMenu: '/charging_card_definitions'
          }
        }
      ]
    }
  ]
}
